import { Auth } from 'aws-amplify'
import { getCookieValue, setCookie, deleteCookie } from "../cookies";
import config from "../../config";


/* 
    use config.cognito.ClientId to prefix if this is DEV or PROD 
    environments
*/
class SessionService {
    // in minutes
    static COOKIE_TIMEOUT : number = 60 * 24 * 365; // 1 year

    constructor() {
    }

    // 
    // Getters

    // get Masqueraded or partner logged from cookie values 
    static getPartnerLogged(checkMasqueraded: boolean = true) : any {
        if(checkMasqueraded){
            let partnerMasquerading = this.getPartnerMasqueraded()
            if(partnerMasquerading != null){
                return partnerMasquerading;
            }
        }

        let partnerLogged = getCookieValue(config.cognito.ClientId + ".partnerLogged");
        if(partnerLogged != null && partnerLogged != undefined){
            try{
                return JSON.parse(partnerLogged);
            } catch (e) {
            }
        }

        return null;
    }
    
    static getPartnerMasqueraded() : any {
        let partnerLogged = getCookieValue(config.cognito.ClientId + ".partnerMasquerading");
        if(partnerLogged != null && partnerLogged != undefined){
            try{
                return JSON.parse(partnerLogged);
            } catch (e) {
            }
        }
        return null;
    }
    
    static getUsernameLogged() : any {
        let usernameLogged = getCookieValue(config.cognito.ClientId + ".usernameLogged");
        if(usernameLogged != null && usernameLogged != undefined){
            return usernameLogged;
        }
        return null;
    }


    // Seller can masquerade and redirect to app. when doing so, a user can have normal session or masqueraded session. so for this functionality 
    // we need another seller masquerading cookie.
    static getPartnerMasqueradedSeller() : any {
        let partnerLogged = getCookieValue(config.cognito.ClientId + ".partnerMasqueradingSeller");
        if(partnerLogged != null && partnerLogged != undefined){
            try{
                return JSON.parse(partnerLogged);
            } catch (e) {
            }
        }
        return null;
    }


    // 
    // Setters
    static setPartnerLogged(partnerLogged: any): void {
        setCookie(config.cognito.ClientId + ".partnerLogged", JSON.stringify(partnerLogged), SessionService.COOKIE_TIMEOUT);
    }
    static setPartnerMasquerading(partnerMasquerading: any): void {
        setCookie(config.cognito.ClientId + ".partnerMasquerading", JSON.stringify(partnerMasquerading), SessionService.COOKIE_TIMEOUT);
    }
    static setPartnerMasqueradingSeller(fromSeller: boolean): void {
        setCookie(config.cognito.ClientId + ".partnerMasqueradingSeller", JSON.stringify(fromSeller), SessionService.COOKIE_TIMEOUT);
    }
    static setUsernameLogged(usernameLogged: string): void {
        setCookie(config.cognito.ClientId + ".usernameLogged", usernameLogged, SessionService.COOKIE_TIMEOUT);
    }

    // 
    // cleanup
    static logout(){
        deleteCookie(config.cognito.ClientId + '.partnerLogged')
        deleteCookie(config.cognito.ClientId + '.partnerMasquerading')
        deleteCookie(config.cognito.ClientId + '.partnerMasqueradingSeller')
        deleteCookie(config.cognito.ClientId + '.usernameLogged')
    }

    static deletePartnerMasquerading(){
        deleteCookie(config.cognito.ClientId + '.partnerMasquerading') 
    }
    static deletePartnerMasqueradingSeller(){
        deleteCookie(config.cognito.ClientId + '.partnerMasqueradingSeller') 
    }

    
    


}

export default SessionService
